module.exports = __webpack_public_path__ + "static/media/dai-coin-icon.3a13ad68.svg";